import { Suspense } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

import AdminsPage from "../../features/admins/components/AdminsPage";

import ActivatePage from "../../features/auth/components/ActivatePage";

import ForgotPasswordPage from "../../features/auth/components/ForgotPasswordPage";

import GoogleCallbackPage from "../../features/auth/components/GoogleCallbackPage";

import LoginPage from "../../features/auth/components/LoginPage";

import ProfileSettingsPage from "../../features/auth/components/ProfileSettingsPage";

import MandatoryTwoFactorPage from "../../features/auth/components/MandatoryTwoFactorPage";

import Recommend2FAPage from "../../features/auth/components/Recommend2FAPage";

import ResetPasswordPage from "../../features/auth/components/ResetPasswordPage";

import SetupPage from "../../features/auth/components/SetupPage";

import ChangelogPage from "../../features/changelog/components/ChangelogPage";

import DesignModerationPage from "../../features/design-moderation/components/DesignModerationPage";

import CloudStreamsPage from "../../features/cloud-streams/components/CloudStreamsPage";

import ContactPage from "../../features/contact/components/ContactPage";

import SupportReportsPage from "../../features/support/components/SupportReportsPage";

import EmailTemplatesPage from "../../features/email-templates/components/EmailTemplatesPage";

import GuestPage from "../../features/guest/components/GuestPage";

import InstallerPage from "../../features/installer/components/InstallerPage";

import IntegrationsPage from "../../features/integrations/components/IntegrationsPage";

import NewsletterPage from "../../features/newsletter/components/NewsletterPage";

import OverlayDetail from "../../features/overlays/components/OverlayDetail";

import OverlaysList from "../../features/overlays/components/OverlaysList";

import PanelDetail from "../../features/panels/components/PanelDetail";

import PanelsList from "../../features/panels/components/PanelsList";

import PlansPage from "../../features/plans/components/PlansPage";

import RomsPage from "../../features/roms/components/RomsPage";

import SecurityPage from "../../features/security/components/SecurityPage";

import SettingsPage from "../../features/settings/components/SettingsPage";

import StatsPage from "../../features/stats/components/StatsPage";

import AnalyticsPage from "../../features/analytics/components/AnalyticsPage";

import StorageBrowserPage from "../../features/storage-browser/components/StorageBrowserPage";

import SubscriptionsPage from "../../features/subscriptions/components/SubscriptionsPage";

import ActiveUsersPage from "../../features/users/components/ActiveUsersPage";

import UserActivityPage from "../../features/users/components/UserActivityPage";

import UninstallsPage from "../../features/users/components/UninstallsPage";

import WorkspacesPage from "../../features/workspaces/components/WorkspacesPage";

import LoadingOverlay from "../../shared/components/LoadingOverlay";

import AppLayout from "../layouts/AppLayout";

import ProtectedRoute from "./ProtectedRoute";

import { useIsViewerOnly } from "../../features/auth/hooks/useHasRole";

const HomeRedirect = () => {
  const isViewerOnly = useIsViewerOnly();

  return <Navigate to={isViewerOnly ? "/stats" : "/integrations"} replace />;
};

const AppRouter = () => (
  <Suspense fallback={<LoadingOverlay />}>
    <Routes>
      <Route path="/setup" element={<SetupPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/login/google/callback" element={<GoogleCallbackPage />} />
      <Route path="/activate/:token" element={<ActivatePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
      <Route path="/recommend-2fa" element={<Recommend2FAPage />} />
      <Route element={<ProtectedRoute />}>
        <Route
          path="/setup-2fa-mandatory"
          element={<MandatoryTwoFactorPage />}
        />
        <Route path="/" element={<AppLayout />}>
          <Route index element={<HomeRedirect />} />
          <Route path="stats" element={<StatsPage />} />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="workspaces" element={<WorkspacesPage />} />
          <Route path="integrations" element={<IntegrationsPage />} />
          <Route path="newsletter" element={<NewsletterPage />} />
          <Route path="overlays">
            <Route index element={<OverlaysList />} />
            <Route path=":slug" element={<OverlayDetail />} />
          </Route>
          <Route path="panels">
            <Route index element={<PanelsList />} />
            <Route path=":slug" element={<PanelDetail />} />
          </Route>
          <Route path="designs" element={<DesignModerationPage />} />
          <Route path="installer" element={<InstallerPage />} />
          <Route path="changelog" element={<ChangelogPage />} />
          <Route path="guest" element={<GuestPage />} />
          <Route path="users">
            <Route index element={<Navigate to="/users/active" replace />} />
            <Route path="active" element={<ActiveUsersPage />} />
            <Route path="activity" element={<UserActivityPage />} />
            <Route path="uninstalls" element={<UninstallsPage />} />
          </Route>
          <Route path="settings" element={<SettingsPage />} />
          <Route path="profile" element={<ProfileSettingsPage />} />
          <Route path="admins" element={<AdminsPage />} />
          <Route path="cloud-streams" element={<CloudStreamsPage />} />
          <Route path="plans" element={<PlansPage />} />
          <Route path="subscriptions" element={<SubscriptionsPage />} />
          <Route path="roms" element={<RomsPage />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="support/reports" element={<SupportReportsPage />} />
          <Route path="email-templates" element={<EmailTemplatesPage />} />
          <Route path="storage" element={<StorageBrowserPage />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Suspense>
);

export default AppRouter;
